import { StrictMode } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import GlobalStyleSetter from './theming/globalStyleSetter';
import AppProvider from './appProvider/appProvider';
import Login from './pages/Authorization/login';
import SignUp from './pages/Authorization/signUp';
import LayoutWrapper from './layoutWrapper';
import ForgotPassword from './pages/Authorization/forgotPassword';
import ResetPassword from './pages/Authorization/resetPassword';
import PromotionalSignup from './pages/Authorization/promotionalSignup';
import { ToastContainer } from 'react-toastify';

const ProtectedRoutes = ({component: Component, ...rest}) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const userKey = params.get('key');

  if(userKey) {
    localStorage.setItem('shp_key', userKey);
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
  }

  const token = localStorage.getItem('token');
  const user_id = localStorage.getItem('user_id');

  return <Route {...rest} render = {props =>
    !!token && !!user_id
    ? <Redirect to='/dashboard' /> 
    : <Component {...props} /> 
  } />
};

function App() {
  return (
    <StrictMode>
      <GlobalStyleSetter />
        <Router>
          <AppProvider>
            <Switch>
              <ProtectedRoutes exact path={'/login'} component={Login} />
              <ProtectedRoutes exact path={'/sign-up'} component={SignUp} />
              <ProtectedRoutes exact path={'/promotional-sign-up'} component={PromotionalSignup} />
              <ProtectedRoutes exact path={'/forgotPassword'} component={ForgotPassword} />
              <ProtectedRoutes exact path={'/resetPassword'} component={ResetPassword} />
              <LayoutWrapper  />
              
            </Switch>
          </AppProvider>
        </Router>
        <ToastContainer position="top-center"
                autoClose={2000}
                hideProgressBar={true}
                newestOnTop={false}
                rtl={false}
                pauseOnHover 
        />
    </StrictMode>
  );
}

export default App;
